import React, { useState } from "react";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckboxTest from "./CheckBoxTest";
import { FinalSelection } from "./FinalSelection";
import { Button } from "@mui/material";
import { AlertPopUp } from "./AlertPopUp";
import Stepper from "@mui/material/Stepper";

export default function OptionsSelection(props) {
  const {
    product,
    variations,
    onVariationClick,
    onSubVariationClick,
    onCounterClick,
    onBackClick,
    onNextClick,
    currentVariation,
    currentLevelConfig,
    steps,
    activeStep,
    onPopUp,
    note,
    onNoteChange,
    settings,
  } = props;

  const [showPopUp, setShowPopUp] = useState(false);

  function _renderStepContent(step, onError) {
    const stepConfig = steps.find((x) => x.level === step);
    switch (stepConfig.componentType) {
      case "selection":
        return (
          <CheckboxTest
            key={step}
            variations={variations.filter((x) => x.level === activeStep)}
            steps={steps}
            activeStep={activeStep}
            currentLevelConfig={currentLevelConfig}
            currentVariation={currentVariation}
            onVariationClick={onVariationClick}
            onSubVariationClick={onSubVariationClick}
            onError={onError}
          />
        );
      case "quantity":
        return (
          <FinalSelection
            rangePrice={product.productSpecialPricings || []}
            quantity={product.quantity}
            onQuantityChange={onCounterClick}
            onPopUp={onPopUp}
            note={note}
            onNoteChange={onNoteChange}
            settings={settings}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  }

  const handlePopUpShow = () => {
    setShowPopUp(true);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {steps.length > 1 ? (
        <Stepper activeStep={activeStep - 1}>
          {steps.map((step, index) => {
            return (
              <Step key={step.level}>
                <StepLabel key={step.level}>{step.label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      ) : null}
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        {steps.length > 1 && activeStep > 1 ? (
          <Button
            color="primary"
            variant="outlined"
            disabled={activeStep === 1}
            onClick={() => onBackClick()}
            sx={{ mr: 1 }}
          >
            Back
          </Button>
        ) : null}

        <Box sx={{ flex: "1 1 auto" }} />

        <AlertPopUp show={showPopUp} />
        {activeStep === steps.length ? null : (
          <Button
            variant="contained"
            disabled={
              variations.filter(
                (x) => x.level == activeStep && x.enabled === true
              ).length <= 0
            }
            onClick={() => onNextClick()}
          >
            Next
          </Button>
        )}
      </Box>

      {steps.length > 0
        ? _renderStepContent(activeStep, handlePopUpShow)
        : null}
    </Box>
  );
}
